import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBackOfficeReasonCode extends Layout {
    dataheaderBackOfficeReasonCode: DataHeader;
    panelBackOfficeReasonCode: Panel;
    sourceBackOfficeReasonCode: DataSource;
    switchIsActive: Switch;
    textboxCodeType: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
